import { Check } from "@/components/Icons";
import { Box, chakra, Flex, Spacer, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

export interface IntroCardProps {
  title: string;
  desc: string;
  featureList: {
    text: string;
    enable: boolean;
  }[];
  button?: ReactNode;
  isHot?: boolean;
}

export default function IntroCard(props: IntroCardProps) {
  const { title, desc, featureList, button, isHot = false } = props;
  return (
    <Flex
      className="business_introCard"
      flexDir="column"
      w="350px"
      h="467px"
      rounded="8px"
      overflow="hidden"
      p="32px"
      bg="white"
      border="1px solid #C9CDD4"
      transition="all 0.1s"
      _hover={{
        borderColor: "#165DFF",
        boxShadow: "0 8px 24px 0 3370FF2c",
        transform: "translateY(-8px)",
      }}
    >
      <Flex
        align="center"
        justify="center"
        textAlign="center"
        color="#1D2129"
        fontSize="20px"
        fontWeight={600}
      >
        <Text>{title}</Text>
        {isHot && (
          <chakra.span
            display="inline-block"
            rounded="full"
            bg="#165DFF"
            color="white"
            p="4px 10px"
            ml="0.5em"
            transform="scale(0.83)"
            transformOrigin="center"
            fontSize="12px"
          >
            热门选择
          </chakra.span>
        )}
      </Flex>
      <Text textAlign="center" mt="12px" fontSize="14px" color="#86909C" mb="22px">
        {desc}
      </Text>
      {featureList.map((feature) => {
        return (
          <Text
            key={feature.text}
            pl="28px"
            pos="relative"
            py="8px"
            color="#4E5969"
            fontSize="14px"
            fontWeight={600}
          >
            <Check
              pos="absolute"
              left="0"
              top="10px"
              boxSize="20px"
              stroke={feature.enable ? "#165DFF" : "#C9CDD4"}
            />
            {feature.text}
          </Text>
        );
      })}
      <Spacer />
      {button}
    </Flex>
  );
}
